// removed by extract-text-webpack-plugin
module.exports = {"root":"styles__root___2VO9O"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/header/styles.css
 ** module id = 168
 ** module chunks = 0
 **/